import * as moment from 'moment'

import { DateValueI } from '@/components/ui'
import { createdAtIntervalOptions } from '@/redux/incidents/incidentsFilterOptions'

type LabelValues = {
  value: unknown
  label: string
}

export interface LabelValueIProps {
  label: string
  value: string
}

export const hours24 = moment.utc().subtract(24, 'hours').format()
export const last2Days = moment.utc().subtract(2, 'days').format()
export const last7Days = moment.utc().subtract(7, 'days').format()
export const last30Days = moment.utc().subtract(30, 'days').format()

export const createdAtOptions = [
  {
    value: {
      gte: hours24,
    },
    label: 'Last 24 hours',
  },
  {
    value: {
      gte: last2Days,
    },
    label: 'Last 2 Days',
  },
  {
    value: {
      gte: last7Days,
    },
    label: 'Last 7 Days',
  },
  {
    value: {
      gte: last30Days,
    },
    label: 'Last 30 Days',
  },
]

// Does the same thing but with clearer names targetting submission times
export const submittedAtIntervalOptions = createdAtIntervalOptions

export const activeIncidentsOptions = [
  { value: true, label: 'Has Active Incidents' },
  { value: false, label: 'Does Not Have Active Incidents' },
]

export const getRelatedFloors = (
  facilities: LabelValues[],
  floors: LabelValues[]
) => {
  return floors?.filter((flr) =>
    facilities?.some((fac) => {
      const facility = fac.label
      const floorFacility = flr.label.substring(
        flr.label.indexOf('(') + 1,
        flr.label.indexOf(')')
      )
      return facility.includes(floorFacility)
    })
  )
}

export const getUniqueValues = (items: LabelValueIProps[]) =>
  [...new Map(items.map((i) => [i.value, i])).values()].filter((e) => e.value)

export interface FilterOptionI<T = string> {
  label: string
  value: T
  color?: string
}

export const isCustomDateRange = (
  dateFilter: FilterOptionI<number | DateValueI>
) => {
  // Check if the value is a number
  const dateAsNumber = Number(dateFilter?.value)
  return isNaN(dateAsNumber)
}
